<script setup lang="ts">
import { useEventCalendarView } from '@/domains/investor/event-calendar/composables/useEventCalendarView'
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import EventCalendarTable from '@/domains/investor/event-calendar/components/EventCalendarTable/EventCalendarTable.vue'
import EventCalendarCards from '@/domains/investor/event-calendar/components/EventCalendarCards/EventCalendarCards.vue'

const { page, perPage, events, total } = await useEventCalendarView()
</script>

<template>
  <div class="eventCalendarView">
    <InvestorHero
      :title="$t('investor.eventCalendar.title')"
      :lead="$t('investor.eventCalendar.lead')"
      image="/images/investor/hero/kalendarium.png"
    />

    <UiSection
      class="eventCalendarView__content"
      color="white"
    >
      <div class="eventCalendarView__inner">

        <UiHeader
          :header="$t('investor.eventCalendar.title')"
          position="center"
          header-size="h5"
          header-size-tablet="h5"
          header-size-mobile="h5"
        />

        <div
          v-if="events.length"
          class="eventCalendarView__results"
        >
          <EventCalendarTable
            class="eventCalendarView__table"
            :events="events"
          />

          <EventCalendarCards
            class="eventCalendarView__cards"
            :events="events"
          />

          <UiPagination
            v-model="page"
            :total="total"
            :items-per-page="perPage"
            class="eventCalendarView__pagination"
          />
        </div>
      </div>
    </UiSection>
  </div>
</template>

<style lang="scss" scoped>
.eventCalendarView {
  &__inner {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
    max-width: 152rem;
    margin: 0 auto;

    @include atM {
      gap: 6.4rem;
    }
  }

  &__results {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
  }

  &__table {
    display: none;

    @include atXS {
      display: block;
    }
  }

  &__cards {
    @include atXS {
      display: none;
    }
  }

  &__pagination {
    justify-content: center;
    margin-top: 0.8rem;
  }
}
</style>
